export { default as useDiseaseEncyclopediaDetailViewModel } from './hooks/useDiseaseEncyclopediaDetailViewModel';

export { default as DiseaseEncyclopediaDetailView } from './ui/DiseaseEncyclopediaDetailView';
